import { components } from 'react-select';
import { Checkbox } from '@mui/material';
import { green } from 'app/components/ThemeProvider/colors';
import React from 'react';

export const SelectOption = (props: any) => {
  return (
    <div>
      <components.Option {...props}>
        {/*<FormControlLabel*/}
        {/*  control={*/}
        {/*    <Checkbox*/}
        {/*      checked={props.isSelected}*/}
        {/*      sx={{*/}
        {/*        color: 'rgba(20, 25, 31, 0.22)',*/}
        {/*        mr: '3px',*/}
        {/*        '&.Mui-checked': {*/}
        {/*          color: green,*/}
        {/*        },*/}
        {/*      }}*/}
        {/*    />*/}
        {/*  }*/}
        {/*  label={props.label}*/}
        {/*  sx={{ fontFamily: 'Yelo' }}*/}
        {/*/>*/}
        {props.label}
      </components.Option>
    </div>
  );
};

export const IconOption = (props: any) => (
  <components.Option {...props}>
    <img src={props.data.label} alt="flags" width="24" height="16" />
    {props.data.text}
  </components.Option>
);

export const PaymentStatusOption = (props: any) => {
  return (
    <components.Option {...props}>
      <Checkbox
        checked={props.isSelected}
        sx={{
          color: 'rgba(20, 25, 31, 0.22)',

          '&.MuiCheckbox-root': {
            padding: '0',
          },
          '&.Mui-checked': {
            color: green,
          },
        }}
      />

      {props.data.icon}
      {props.data.label}
    </components.Option>
  );
};

export const OptionsWithIcon = (props: any) => {
  return (
    <components.Option {...props}>
      {props.data.icon}
      {props.data.label}
    </components.Option>
  );
};

export const TemplateTypeOption = (props: any) => {
  return (
    <components.Option {...props}>
      <Checkbox
        checked={props.isSelected}
        sx={{
          color: 'rgba(20, 25, 31, 0.22)',

          '&.MuiCheckbox-root': {
            padding: '0',
          },
          '&.Mui-checked': {
            color: green,
          },
        }}
      />
      {props.data.label}
    </components.Option>
  );
};
